import { render, staticRenderFns } from "./Finding.vue?vue&type=template&id=22fcac68&"
import script from "./Finding.vue?vue&type=script&lang=js&"
export * from "./Finding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports